import React from 'react';
import Img from 'react-image';
import placeholder from './product-placeholder.png';

export const Placeholder = ({alt, style}) => <div style={style} className="flex items-center">
    <img src={placeholder as any} className="rounded-t-lg" alt={alt}/>
</div>;
export default function Image({
                                  url,
                                  alt = 'placeholder',
                                  className,
                                  style,
                              }: {
    url?: string | [string];
    alt?: string;
    className?: string;
    style?: any;
}) {
    return (
        <Img
            draggable={false}
            style={style}
            src={url}
            alt={alt}
            loader={<Placeholder alt={alt} style={style}/>}
            unloader={<Placeholder alt={alt} style={style}/>}
            className={className}
        />
    );
}
